import { render, staticRenderFns } from "./HotProduct.vue?vue&type=template&id=3fdfe2b7&scoped=true&"
import script from "./HotProduct.vue?vue&type=script&lang=js&"
export * from "./HotProduct.vue?vue&type=script&lang=js&"
import style0 from "./HotProduct.vue?vue&type=style&index=0&id=3fdfe2b7&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fdfe2b7",
  null
  
)

export default component.exports